/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';

import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sendProductFeedback } from '../../app/store/actions/productFeedback';


class ProductFeedback extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      websiteReview: 0,
      reason: '',
      feedback: '',
      messageErro: '',
    };
    this.initialState = this.state;
  }

  sendProductFeedback = async () => {
    const { websiteReview, feedback, reason } = this.state;
    if (!websiteReview || !reason || !feedback) {
      this.setState({ messageErro: I18n.t('productFeedbackNotice') });
    } else {
      try {
        await this.props.sendProductFeedback(this.props.productSoneparId, websiteReview, reason, feedback);
        this.closeProductFeedback();
      } catch (error) {
        this.setState({ messageErro: I18n.t('errorTryLater') });
      }
    }
  }

  closeProductFeedback = () => {
    this.props.closeProductFeedback();
    this.setState({ ...this.initialState });
  }

  render() {
    const { showModalProductFeedback = false, listProductFeedbackReason = [] } = this.props;
    const {
      websiteReview, feedback, reason, messageErro,
    } = this.state;
    return (
      <div
        className="modal"
        role="presentation"
        id="product-feedback"
        style={{ display: showModalProductFeedback ? 'block' : 'none', zIndex: '10' }}
      >
        <div className="modal-content modal-content-product-feedback">
          <div className="modal-body">
            <div className="product-feedback-modal-close">
              <FontAwesomeIcon icon={faTimes} onClick={this.closeProductFeedback} />
            </div>
            <div className="column body-modal-text" style={{ padding: '10px 0 40px 0' }}>
              <div className="_reason-cancel-order">
                <p className="product-feedback-label">
                  {I18n.t('websiteReview')}
                </p>
                <div className="product-feedback-row-emoji">
                  <span
                    className={`emoji ${(websiteReview === 1) ? 'emoji_selected ' : ''}`}
                    onClick={() => this.setState({ websiteReview: 1 })}
                  >
                    ☹️
                  </span>
                  <span
                    className={`emoji ${(websiteReview === 2) ? 'emoji_selected ' : ''}`}
                    onClick={() => this.setState({ websiteReview: 2 })}
                  >
                    😕
                  </span>
                  <span
                    className={`emoji ${(websiteReview === 3) ? 'emoji_selected ' : ''}`}
                    onClick={() => this.setState({ websiteReview: 3 })}
                  >
                    😐
                  </span>
                  <span
                    className={`emoji ${(websiteReview === 4) ? 'emoji_selected ' : ''}`}
                    onClick={() => this.setState({ websiteReview: 4 })}
                  >
                    🙂
                  </span>
                  <span
                    className={`emoji ${(websiteReview === 5) ? 'emoji_selected ' : ''}`}
                    onClick={() => this.setState({ websiteReview: 5 })}
                  >
                    ❤️
                  </span>
                </div>
                <div className="product-feedback-row ">
                  <p className="product-feedback-label">
                    {I18n.t('reasonForFeedback')}
                  </p>
                  <select
                    className="product-feedback-select"
                    name="filterBy"
                    value={reason}
                    onChange={e => this.setState({ reason: e.target.value })}
                  >
                    <option
                      key="selectAnOption"
                      value=""
                    >
                      {I18n.t('selectAnOption')}
                    </option>
                    {listProductFeedbackReason.map(elem => (
                      <option
                        key={elem.id}
                        value={elem.id}
                      >
                        {elem.reason}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="product-feedback-row">
                  <p className="product-feedback-label">
                    {I18n.t('feedback')}
                  </p>
                  <textarea
                    rows="5"
                    type="text"
                    className="product-feedback-textarea"
                    maxLength={500}
                    value={feedback}
                    onChange={e => this.setState({ feedback: e.target.value })}
                  />
                </div>
              </div>
              <button
                type="button"
                className="button-product-feedback"
                onClick={() => this.sendProductFeedback()}
              >
                {I18n.t('submit')}
              </button>
              {!!messageErro && (
                <p
                  className="product-feedback-label"
                  style={{ marginTop: '20px', color: 'red' }}
                >
                  {messageErro}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  listProductFeedbackReason: state.settings.listProductFeedbackReason,
});

const mapDispatchToProps = dispatch => ({
  sendProductFeedback: (productSoneparId, websiteReview, productFeedbackReasonId, feedback) => dispatch(
    sendProductFeedback(productSoneparId, websiteReview, productFeedbackReasonId, feedback),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductFeedback);
